import { createSelector } from '@reduxjs/toolkit';
import { ELayoutType } from '../../../../packages/api-models/common/json_query';
import { selectLayoutType, selectOfferType } from 'shared/selectors/jsonQuery';
import { isUrban } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Смежная', value: ELayoutType.UnitedRooms },
  { label: 'Изолированная', value: ELayoutType.IsolatedRooms },
];

export const selectLayoutFilter = createSelector([selectLayoutType, selectOfferType], (value, offerType) => ({
  label: 'Планировка',
  value: [value],
  options: OPTIONS,
  visible: isUrban(offerType),
}));
